import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        async getPartnerCompanyList(filter) {
            var meta = { clientApiMethod: 'getPartnerCompanyList', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "PartnerCompany", { params: filter, meta: meta })
            return response?.data;
        },
        async getPartnerCompanyById(id) {
            var meta = { clientApiMethod: 'getPartnerCompany', input: { id: id } }
            var response = await client().get(store.state.apiRouteRoot + "PartnerCompany/" + id, { meta: meta })
            return response?.data;
        },
        async createPartnerCompany(newPartnerCompany) {
            var meta = {
                clientApiMethod: 'createPartnerCompany',
                input: { newPartnerCompany },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.partner_company.partner_company") })
            }
            var response = await client().post(store.state.apiRouteRoot + 'PartnerCompany', newPartnerCompany, { meta: meta })
            return response?.data;
        },
        async changePartnerCompany(updatedPartnerCompany) {
            var meta = {
                clientApiMethod: 'changePartnerCompany',
                input: { updatedPartnerCompany },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.partner_company.partner_company") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'PartnerCompany', updatedPartnerCompany, { meta: meta })
            return response?.data;
        },
        async deletePartnerCompany(PartnerCompanyId) {
            var meta = {
                clientApiMethod: 'deletePartnerCompany',
                input: { PartnerCompanyId: PartnerCompanyId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.partner_company.partner_company") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "PartnerCompany/" + PartnerCompanyId, { meta: meta })
            return response?.data;
        },
    }
}